// extracted by mini-css-extract-plugin
export var readonly = "_de-1";
export var star = "_de-0";